import Row from '@/components/LayoutTools/Sidebar/items/SharedFeatures/Row';
import SidebarItem from '@/components/LayoutTools/Sidebar/items/SidebarItem';
import { Box, Collapse } from '@mui/material';
import React, { useState } from 'react';

export default function ExpandableItem({
  label,
  icon,
  items,
  sidebarWidth,
  isMobile,
  toggleResize,
  isChild = false,
  lastChild = false,
  level = 0,
}) {
  const [open, setOpen] = useState(false);

  function toggleSubmenu() {
    if (sidebarWidth < 80) {
      toggleResize();
    }
    setOpen(!open);
  }

  function handleKeypress(e) {
    if (e.keyCode === 13) {
      toggleSubmenu();
    }
  }

  return (
    <>
      <Box
        onClick={toggleSubmenu}
        onKeyDown={handleKeypress}
        tabIndex='0'
        role='button'
      >
        <Row
          icon={icon}
          label={label}
          open={open}
          expandable={true}
          isChild={isChild}
          lastChild={lastChild}
          active={false}
          level={level}
        />
      </Box>

      <Collapse in={open && (sidebarWidth >= 80 || isMobile)}>
        <Box
          sx={{
            display: 'flex',
          }}
        >
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {items.map((subItem, i) => (
              <SidebarItem
                key={`${subItem.label}-${i}`}
                sidebarWidth={sidebarWidth}
                toggleResize={toggleResize}
                isMobile={isMobile}
                {...subItem}
                isChild={true}
                lastChild={items.indexOf(subItem) === items.length - 1}
                level={level + 1} // Increase level for nested items
              />
            ))}
          </Box>
        </Box>
      </Collapse>
    </>
  );
}
